import supabase from '../config/supabase';
import {
  STUDENT_IMPORT_BACKUP_TABLES,
  buildStudentImportBackupSql,
} from '../utils/studentImportBackupSql';
import { handleServiceError } from '../utils/errorHandler';

const PAGE_SIZE = 1000;

class StudentImportBackupServiceClass {
  private async loadTable(tableName: string, columns: readonly string[], orderColumn: string) {
    const rows: Record<string, unknown>[] = [];
    let from = 0;

    while (true) {
      const { data, error } = await supabase
        .from(tableName)
        .select(columns.join(','))
        .order(orderColumn, { ascending: true })
        .range(from, from + PAGE_SIZE - 1);

      if (error) {
        handleServiceError(error, 'gerar o backup');
      }

      const page = (data ?? []) as unknown as Record<string, unknown>[];
      rows.push(...page);
      if (page.length < PAGE_SIZE) {
        return rows;
      }
      from += PAGE_SIZE;
    }
  }

  async buildSql(): Promise<string> {
    const rowsByTable: Record<string, Record<string, unknown>[]> = {};

    for (const table of STUDENT_IMPORT_BACKUP_TABLES) {
      rowsByTable[table.name] = await this.loadTable(
        table.name,
        table.columns.map((column) => column.name),
        table.orderColumn,
      );
    }

    return buildStudentImportBackupSql(rowsByTable, new Date());
  }
}

export const StudentImportBackupService = new StudentImportBackupServiceClass();
